import { animate, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component, Input, signal } from '@angular/core';
import { FwIconModule, IconType } from '@flywheel-io/vision';

@Component({
  selector: 'app-expansion-panel',
  standalone: true,
  imports: [
    FwIconModule,
  ],
  templateUrl: './expansion-panel.component.html',
  styleUrls: ['./expansion-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('expandCollapse', [
      state('true', style({
        height: '*',
        opacity: 1,
      })),
      state('false', style({
        height: '0px',
        opacity: 0,
      })),
      transition('true <=> false', [
        animate('100ms cubic-bezier(0.4, 0.0, 0.2, 1)'),
      ]),
    ]),
  ],
})
export class ExpansionPanelComponent {
  @Input() title: string;
  @Input() icon: IconType;
  @Input() set expanded(value: boolean) {
    this.isExpanded.set(value);
  }

  protected isExpanded = signal(true);

  protected toggle(): void {
    this.isExpanded.update(expanded => !expanded);
  }
}
